const Fn = {
    //
    // import Katana from './img/Equipment/Weapon/Katana.gif'
    KatanaBonusSTR: 0,
    KatanaBonusAGI: 0,
    KatanaBonusVIT: 0,
    KatanaBonusINT: 0,
    KatanaBonusDEX: 0,
    KatanaBonusLUK: 0,
    KatanaBonusAttack: 0,
    KatanaBonusSpeed: 0,
    KatanaBonusDodgeRate: 0,
    KatanaBonusDefence: 0,
    KatanaBonusDefenceBuffer: 0,
    KatanaBonusHitRate: 0,
    KatanaBonusCritRate: 0,
    KatanaBonusHealth: 0,
    KatanaBonusSP: 0,
    // import BastardSword from './img/Equipment/Weapon/BastardSword.gif'
    BastardSwordBonusSTR: 0,
    BastardSwordBonusAGI: 0,
    BastardSwordBonusVIT: 0,
    BastardSwordBonusINT: 0,
    BastardSwordBonusDEX: 0,
    BastardSwordBonusLUK: 0,
    BastardSwordBonusAttack: 0,
    BastardSwordBonusSpeed: 0,
    BastardSwordBonusDodgeRate: 0,
    BastardSwordBonusDefence: 0,
    BastardSwordBonusDefenceBuffer: 0,
    BastardSwordBonusHitRate: 0,
    BastardSwordBonusCritRate: 0,
    BastardSwordBonusHealth: 0,
    BastardSwordBonusSP: 0,
    // import GaiaSword from './img/Equipment/Weapon/GaiaSword.gif'
    GaiaSwordBonusSTR: 0,
    GaiaSwordBonusAGI: 0,
    GaiaSwordBonusVIT: 0,
    GaiaSwordBonusINT: 0,
    GaiaSwordBonusDEX: 0,
    GaiaSwordBonusLUK: 0,
    GaiaSwordBonusAttack: 0,
    GaiaSwordBonusSpeed: 0,
    GaiaSwordBonusDodgeRate: 0,
    GaiaSwordBonusDefence: 0,
    GaiaSwordBonusDefenceBuffer: 0,
    GaiaSwordBonusHitRate: 0,
    GaiaSwordBonusCritRate: 0,
    GaiaSwordBonusHealth: 0,
    GaiaSwordBonusSP: 0,
    // import TwinEdgeofNaghtSieger from './img/Equipment/Weapon/TwinEdgeofNaghtSieger.gif'
    TwinEdgeofNaghtSiegerBonusSTR: 1,
    TwinEdgeofNaghtSiegerBonusAGI: 1,
    TwinEdgeofNaghtSiegerBonusVIT: 1,
    TwinEdgeofNaghtSiegerBonusINT: 1,
    TwinEdgeofNaghtSiegerBonusDEX: 1,
    TwinEdgeofNaghtSiegerBonusLUK: 1,
    TwinEdgeofNaghtSiegerBonusAttack: 10,
    TwinEdgeofNaghtSiegerBonusSpeed: 0,
    TwinEdgeofNaghtSiegerBonusDodgeRate: 0,
    TwinEdgeofNaghtSiegerBonusDefence: 0,
    TwinEdgeofNaghtSiegerBonusDefenceBuffer: 0,
    TwinEdgeofNaghtSiegerBonusHitRate: 0,
    TwinEdgeofNaghtSiegerBonusCritRate: 0,
    TwinEdgeofNaghtSiegerBonusHealth: 0,
    TwinEdgeofNaghtSiegerBonusSP: 0,
    // import VioletFear from './img/Equipment/Weapon/VioletFear.gif'
    VioletFearBonusSTR: 7,
    VioletFearBonusAGI: 7,
    VioletFearBonusVIT: 7,
    VioletFearBonusINT: 7,
    VioletFearBonusDEX: 7,
    VioletFearBonusLUK: 7,
    VioletFearBonusAttack: 777,
    VioletFearBonusSpeed: 0.07,
    VioletFearBonusDodgeRate: 0.07,
    VioletFearBonusDefence: 77,
    VioletFearBonusDefenceBuffer: 77,
    VioletFearBonusHitRate: 0.77,
    VioletFearBonusCritRate: 0.77,
    VioletFearBonusHealth: 700,
    VioletFearBonusSP: 70,
    // HEADGEAR
    // import TeddybearHat from './img/Equipment/HeadGear/TeddybearHat.gif'
    TeddybearBonusSTR: 0,
    TeddybearBonusAGI: 0,
    TeddybearBonusVIT: 0,
    TeddybearBonusINT: 0,
    TeddybearBonusDEX: 0,
    TeddybearBonusLUK: 0,
    TeddybearBonusAttack: 0,
    TeddybearBonusSpeed: 0,
    TeddybearBonusDodgeRate: 0,
    TeddybearBonusDefence: 0,
    TeddybearBonusDefenceBuffer: 0,
    TeddybearBonusHitRate: 0,
    TeddybearBonusCritRate: 0,
    TeddybearBonusHealth: 0,
    TeddybearBonusSP: 0,
    // import Crown from './img/Equipment/HeadGear/Crown.gif'
    CrownBonusSTR: 0,
    CrownBonusAGI: 0,
    CrownBonusVIT: 0,
    CrownBonusINT: 0,
    CrownBonusDEX: 0,
    CrownBonusLUK: 0,
    CrownBonusAttack: 0,
    CrownBonusSpeed: 0,
    CrownBonusDodgeRate: 0,
    CrownBonusDefence: 0,
    CrownBonusDefenceBuffer: 0,
    CrownBonusHitRate: 0,
    CrownBonusCritRate: 0,
    CrownBonusHealth: 0,
    CrownBonusSP: 0,
    // import Helm from './img/Equipment/HeadGear/Helm.gif'
    HelmBonusSTR: 0,
    HelmBonusAGI: 0,
    HelmBonusVIT: 0,
    HelmBonusINT: 0,
    HelmBonusDEX: 0,
    HelmBonusLUK: 0,
    HelmBonusAttack: 0,
    HelmBonusSpeed: 0,
    HelmBonusDodgeRate: 0,
    HelmBonusDefence: 0,
    HelmBonusDefenceBuffer: 0,
    HelmBonusHitRate: 0,
    HelmBonusCritRate: 0,
    HelmBonusHealth: 0,
    HelmBonusSP: 0,
    // import PandaHat from './img/Equipment/HeadGear/PandaHat.gif'
    PandaHatBonusSTR: 0,
    PandaHatBonusAGI: 0,
    PandaHatBonusVIT: 0,
    PandaHatBonusINT: 0,
    PandaHatBonusDEX: 0,
    PandaHatBonusLUK: 0,
    PandaHatBonusAttack: 0,
    PandaHatBonusSpeed: 0,
    PandaHatBonusDodgeRate: 0,
    PandaHatBonusDefence: 0,
    PandaHatBonusDefenceBuffer: 0,
    PandaHatBonusHitRate: 0,
    PandaHatBonusCritRate: 0,
    PandaHatBonusHealth: 0,
    PandaHatBonusSP: 0,
    // import ChefHat from './img/Equipment/HeadGear/ChefHat.gif'
    ChefHatBonusSTR: 0,
    ChefHatBonusAGI: 0,
    ChefHatBonusVIT: 0,
    ChefHatBonusINT: 0,
    ChefHatBonusDEX: 0,
    ChefHatBonusLUK: 0,
    ChefHatBonusAttack: 0,
    ChefHatBonusSpeed: 0,
    ChefHatBonusDodgeRate: 0,
    ChefHatBonusDefence: 0,
    ChefHatBonusDefenceBuffer: 0,
    ChefHatBonusHitRate: 0,
    ChefHatBonusCritRate: 0,
    ChefHatBonusHealth: 0,
    ChefHatBonusSP: 0,
    // import SantaPoringHat from './img/Equipment/HeadGear/SantaPoringHat.gif'
    SantaPoringHatBonusSTR: 0,
    SantaPoringHatBonusAGI: 0,
    SantaPoringHatBonusVIT: 0,
    SantaPoringHatBonusINT: 0,
    SantaPoringHatBonusDEX: 0,
    SantaPoringHatBonusLUK: 0,
    SantaPoringHatBonusAttack: 0,
    SantaPoringHatBonusSpeed: 0,
    SantaPoringHatBonusDodgeRate: 0,
    SantaPoringHatBonusDefence: 0,
    SantaPoringHatBonusDefenceBuffer: 0,
    SantaPoringHatBonusHitRate: 0,
    SantaPoringHatBonusCritRate: 0,
    SantaPoringHatBonusHealth: 0,
    SantaPoringHatBonusSP: 0,
    // import LordKahosHorn from './img/Equipment/HeadGear/LordKahosHorn.gif'
    LordKahosHornBonusSTR: 10,
    LordKahosHornBonusAGI: 10,
    LordKahosHornBonusVIT: 10,
    LordKahosHornBonusINT: 10,
    LordKahosHornBonusDEX: 10,
    LordKahosHornBonusLUK: 10,
    LordKahosHornBonusAttack: 0,
    LordKahosHornBonusSpeed: 0,
    LordKahosHornBonusDodgeRate: 0,
    LordKahosHornBonusDefence: 0,
    LordKahosHornBonusDefenceBuffer: 0,
    LordKahosHornBonusHitRate: 0,
    LordKahosHornBonusCritRate: 0,
    LordKahosHornBonusHealth: 100,
    LordKahosHornBonusSP: 100,
    //ARMOR
    // import CottonShirt from './img/Equipment/Armor/CottonShirt.gif'
    CottonShirtBonusSTR: 0,
    CottonShirtBonusAGI: 0,
    CottonShirtBonusVIT: 0,
    CottonShirtBonusINT: 0,
    CottonShirtBonusDEX: 0,
    CottonShirtBonusLUK: 0,
    CottonShirtBonusAttack: 0,
    CottonShirtBonusSpeed: 0,
    CottonShirtBonusDodgeRate: 0,
    CottonShirtBonusDefence: 0,
    CottonShirtBonusDefenceBuffer: 0,
    CottonShirtBonusHitRate: 0,
    CottonShirtBonusCritRate: 0,
    CottonShirtBonusHealth: 0,
    CottonShirtBonusSP: 0,
    // import AdventureSuit from './img/Equipment/Armor/AdventurersSuit.gif'
    AdventurersSuitBonusSTR: 0,
    AdventurersSuitBonusAGI: 0,
    AdventurersSuitBonusVIT: 0,
    AdventurersSuitBonusINT: 0,
    AdventurersSuitBonusDEX: 0,
    AdventurersSuitBonusLUK: 0,
    AdventurersSuitBonusAttack: 0,
    AdventurersSuitBonusSpeed: 0,
    AdventurersSuitBonusDodgeRate: 0,
    AdventurersSuitBonusDefence: 0,
    AdventurersSuitBonusDefenceBuffer: 0,
    AdventurersSuitBonusHitRate: 0,
    AdventurersSuitBonusCritRate: 0,
    AdventurersSuitBonusHealth: 0,
    AdventurersSuitBonusSP: 0,
    // import WoodenMail from './img/Equipment/Armor/WoodenMail.gif'
    WoodenMailBonusSTR: 0,
    WoodenMailBonusAGI: 0,
    WoodenMailBonusVIT: 0,
    WoodenMailBonusINT: 0,
    WoodenMailBonusDEX: 0,
    WoodenMailBonusLUK: 0,
    WoodenMailBonusAttack: 0,
    WoodenMailBonusSpeed: 0,
    WoodenMailBonusDodgeRate: 0,
    WoodenMailBonusDefence: 0,
    WoodenMailBonusDefenceBuffer: 0,
    WoodenMailBonusHitRate: 0,
    WoodenMailBonusCritRate: 0,
    WoodenMailBonusHealth: 0,
    WoodenMailBonusSP: 0,
    // import Coat from './img/Equipment/Armor/Coat.gif'
    CoatBonusSTR: 0,
    CoatBonusAGI: 0,
    CoatBonusVIT: 0,
    CoatBonusINT: 0,
    CoatBonusDEX: 0,
    CoatBonusLUK: 0,
    CoatBonusAttack: 0,
    CoatBonusSpeed: 0,
    CoatBonusDodgeRate: 0,
    CoatBonusDefence: 0,
    CoatBonusDefenceBuffer: 0,
    CoatBonusHitRate: 0,
    CoatBonusCritRate: 0,
    CoatBonusHealth: 0,
    CoatBonusSP: 0,
    // import PaddedArmor from './img/Equipment/Armor/PaddedArmor.gif'
    PaddedArmorBonusSTR: 0,
    PaddedArmorBonusAGI: 0,
    PaddedArmorBonusVIT: 0,
    PaddedArmorBonusINT: 0,
    PaddedArmorBonusDEX: 0,
    PaddedArmorBonusLUK: 0,
    PaddedArmorBonusAttack: 0,
    PaddedArmorBonusSpeed: 0,
    PaddedArmorBonusDodgeRate: 0,
    PaddedArmorBonusDefence: 0,
    PaddedArmorBonusDefenceBuffer: 0,
    PaddedArmorBonusHitRate: 0,
    PaddedArmorBonusCritRate: 0,
    PaddedArmorBonusHealth: 0,
    PaddedArmorBonusSP: 0,
    // import ChainMail from './img/Equipment/Armor/ChainMail.gif'
    ChainMailBonusSTR: 0,
    ChainMailBonusAGI: 0,
    ChainMailBonusVIT: 0,
    ChainMailBonusINT: 0,
    ChainMailBonusDEX: 0,
    ChainMailBonusLUK: 0,
    ChainMailBonusAttack: 0,
    ChainMailBonusSpeed: 0,
    ChainMailBonusDodgeRate: 0,
    ChainMailBonusDefence: 0,
    ChainMailBonusDefenceBuffer: 0,
    ChainMailBonusHitRate: 0,
    ChainMailBonusCritRate: 0,
    ChainMailBonusHealth: 0,
    ChainMailBonusSP: 0,
    // import FullPlate from './img/Equipment/Armor/FullPlate.gif'
    FullPlateBonusSTR: 0,
    FullPlateBonusAGI: 0,
    FullPlateBonusVIT: 0,
    FullPlateBonusINT: 0,
    FullPlateBonusDEX: 0,
    FullPlateBonusLUK: 0,
    FullPlateBonusAttack: 0,
    FullPlateBonusSpeed: 0,
    FullPlateBonusDodgeRate: 0,
    FullPlateBonusDefence: 0,
    FullPlateBonusDefenceBuffer: 0,
    FullPlateBonusHitRate: 0,
    FullPlateBonusCritRate: 0,
    FullPlateBonusHealth: 0,
    FullPlateBonusSP: 0,
    //GARMENT
    // import Hood from './img/Equipment/Garment/Hood.gif'
    HoodBonusSTR: 0,
    HoodBonusAGI: 0,
    HoodBonusVIT: 0,
    HoodBonusINT: 0,
    HoodBonusDEX: 0,
    HoodBonusLUK: 0,
    HoodBonusAttack: 0,
    HoodBonusSpeed: 0,
    HoodBonusDodgeRate: 0,
    HoodBonusDefence: 0,
    HoodBonusDefenceBuffer: 0,
    HoodBonusHitRate: 0,
    HoodBonusCritRate: 0,
    HoodBonusHealth: 0,
    HoodBonusSP: 0,
    // import Muffler from './img/Equipment/Garment/Muffler.gif'
    MufflerBonusSTR: 0,
    MufflerBonusAGI: 0,
    MufflerBonusVIT: 0,
    MufflerBonusINT: 0,
    MufflerBonusDEX: 0,
    MufflerBonusLUK: 0,
    MufflerBonusAttack: 0,
    MufflerBonusSpeed: 0,
    MufflerBonusDodgeRate: 0,
    MufflerBonusDefence: 0,
    MufflerBonusDefenceBuffer: 0,
    MufflerBonusHitRate: 0,
    MufflerBonusCritRate: 0,
    MufflerBonusHealth: 0,
    MufflerBonusSP: 0,
    // import Manteau from './img/Equipment/Garment/Manteau.gif'
    ManteauBonusSTR: 0,
    ManteauBonusAGI: 0,
    ManteauBonusVIT: 0,
    ManteauBonusINT: 0,
    ManteauBonusDEX: 0,
    ManteauBonusLUK: 0,
    ManteauBonusAttack: 0,
    ManteauBonusSpeed: 0,
    ManteauBonusDodgeRate: 0,
    ManteauBonusDefence: 0,
    ManteauBonusDefenceBuffer: 0,
    ManteauBonusHitRate: 0,
    ManteauBonusCritRate: 0,
    ManteauBonusHealth: 0,
    ManteauBonusSP: 0,
    // import FalconMuffler from './img/Equipment/Garment/FalconMuffler.gif'
    FalconMufflerBonusSTR: 0,
    FalconMufflerBonusAGI: 0,
    FalconMufflerBonusVIT: 0,
    FalconMufflerBonusINT: 0,
    FalconMufflerBonusDEX: 0,
    FalconMufflerBonusLUK: 0,
    FalconMufflerBonusAttack: 0,
    FalconMufflerBonusSpeed: 0,
    FalconMufflerBonusDodgeRate: 0,
    FalconMufflerBonusDefence: 0,
    FalconMufflerBonusDefenceBuffer: 0,
    FalconMufflerBonusHitRate: 0,
    FalconMufflerBonusCritRate: 0,
    FalconMufflerBonusHealth: 0,
    FalconMufflerBonusSP: 0,
    // import ValisManteau from './img/Equipment/Garment/ValisManteau.gif'
    ValisManteauBonusSTR: 0,
    ValisManteauBonusAGI: 0,
    ValisManteauBonusVIT: 0,
    ValisManteauBonusINT: 0,
    ValisManteauBonusDEX: 0,
    ValisManteauBonusLUK: 0,
    ValisManteauBonusAttack: 0,
    ValisManteauBonusSpeed: 0,
    ValisManteauBonusDodgeRate: 0,
    ValisManteauBonusDefence: 0,
    ValisManteauBonusDefenceBuffer: 0,
    ValisManteauBonusHitRate: 0,
    ValisManteauBonusCritRate: 0,
    ValisManteauBonusHealth: 0,
    ValisManteauBonusSP: 0,
    // import ValkyrianManteau from './img/Equipment/Garment/ValkyrianManteau.gif'
    ValkyrianManteauBonusSTR: 0,
    ValkyrianManteauBonusAGI: 0,
    ValkyrianManteauBonusVIT: 0,
    ValkyrianManteauBonusINT: 0,
    ValkyrianManteauBonusDEX: 0,
    ValkyrianManteauBonusLUK: 0,
    ValkyrianManteauBonusAttack: 0,
    ValkyrianManteauBonusSpeed: 0,
    ValkyrianManteauBonusDodgeRate: 0,
    ValkyrianManteauBonusDefence: 0,
    ValkyrianManteauBonusDefenceBuffer: 0,
    ValkyrianManteauBonusHitRate: 0,
    ValkyrianManteauBonusCritRate: 0,
    ValkyrianManteauBonusHealth: 0,
    ValkyrianManteauBonusSP: 0,
    // import WoolScarf from './img/Equipment/Garment/WoolScarf.gif'
    WoolScarfBonusSTR: 0,
    WoolScarfBonusAGI: 0,
    WoolScarfBonusVIT: 0,
    WoolScarfBonusINT: 0,
    WoolScarfBonusDEX: 0,
    WoolScarfBonusLUK: 0,
    WoolScarfBonusAttack: 0,
    WoolScarfBonusSpeed: 0,
    WoolScarfBonusDodgeRate: 0,
    WoolScarfBonusDefence: 0,
    WoolScarfBonusDefenceBuffer: 0,
    WoolScarfBonusHitRate: 0,
    WoolScarfBonusCritRate: 0,
    WoolScarfBonusHealth: 0,
    WoolScarfBonusSP: 0,
    // import FallenAngelWing from './img/Equipment/Garment/FallenAngelWing.gif'
    FallenAngelWingBonusSTR: 0,
    FallenAngelWingBonusAGI: 0,
    FallenAngelWingBonusVIT: 0,
    FallenAngelWingBonusINT: 0,
    FallenAngelWingBonusDEX: 0,
    FallenAngelWingBonusLUK: 0,
    FallenAngelWingBonusAttack: 0,
    FallenAngelWingBonusSpeed: 0,
    FallenAngelWingBonusDodgeRate: 0,
    FallenAngelWingBonusDefence: 0,
    FallenAngelWingBonusDefenceBuffer: 0,
    FallenAngelWingBonusHitRate: 0,
    FallenAngelWingBonusCritRate: 0,
    FallenAngelWingBonusHealth: 0,
    FallenAngelWingBonusSP: 0,
    // import CloakofGray from './img/Equipment/Garment/CloakofGray.gif'
    CloakofGrayBonusSTR: 0,
    CloakofGrayBonusAGI: 0,
    CloakofGrayBonusVIT: 0,
    CloakofGrayBonusINT: 0,
    CloakofGrayBonusDEX: 0,
    CloakofGrayBonusLUK: 0,
    CloakofGrayBonusAttack: 0,
    CloakofGrayBonusSpeed: 0,
    CloakofGrayBonusDodgeRate: 0,
    CloakofGrayBonusDefence: 0,
    CloakofGrayBonusDefenceBuffer: 0,
    CloakofGrayBonusHitRate: 0,
    CloakofGrayBonusCritRate: 0,
    CloakofGrayBonusHealth: 0,
    CloakofGrayBonusSP: 0,
    // import ElementalCape from './img/Equipment/Garment/ElementalCape.gif'
    ElementalCapeBonusSTR: 0,
    ElementalCapeBonusAGI: 0,
    ElementalCapeBonusVIT: 0,
    ElementalCapeBonusINT: 0,
    ElementalCapeBonusDEX: 0,
    ElementalCapeBonusLUK: 0,
    ElementalCapeBonusAttack: 0,
    ElementalCapeBonusSpeed: 0,
    ElementalCapeBonusDodgeRate: 0,
    ElementalCapeBonusDefence: 0,
    ElementalCapeBonusDefenceBuffer: 0,
    ElementalCapeBonusHitRate: 0,
    ElementalCapeBonusCritRate: 0,
    ElementalCapeBonusHealth: 0,
    ElementalCapeBonusSP: 0,
    // import Asprika from './img/Equipment/Garment/Asprika.gif'
    AsprikaBonusSTR: 0,
    AsprikaBonusAGI: 0,
    AsprikaBonusVIT: 0,
    AsprikaBonusINT: 0,
    AsprikaBonusDEX: 0,
    AsprikaBonusLUK: 0,
    AsprikaBonusAttack: 10,
    AsprikaBonusSpeed: 0.1,
    AsprikaBonusDodgeRate: 0.1,
    AsprikaBonusDefence: 10,
    AsprikaBonusDefenceBuffer: 10,
    AsprikaBonusHitRate: 0.1,
    AsprikaBonusCritRate: 0.1,
    AsprikaBonusHealth: 100,
    AsprikaBonusSP: 100,
    //FOOTGEAR
    // import Sandals from './img/Equipment/FootGear/Sandals.gif'
    SandalsBonusSTR: 0,
    SandalsBonusAGI: 0,
    SandalsBonusVIT: 0,
    SandalsBonusINT: 0,
    SandalsBonusDEX: 0,
    SandalsBonusLUK: 0,
    SandalsBonusAttack: 0,
    SandalsBonusSpeed: 0,
    SandalsBonusDodgeRate: 0,
    SandalsBonusDefence: 0,
    SandalsBonusDefenceBuffer: 0,
    SandalsBonusHitRate: 0,
    SandalsBonusCritRate: 0,
    SandalsBonusHealth: 0,
    SandalsBonusSP: 0,
    // import Shoes from './img/Equipment/FootGear/Shoes.gif'
    ShoesBonusSTR: 0,
    ShoesBonusAGI: 0,
    ShoesBonusVIT: 0,
    ShoesBonusINT: 0,
    ShoesBonusDEX: 0,
    ShoesBonusLUK: 0,
    ShoesBonusAttack: 0,
    ShoesBonusSpeed: 0,
    ShoesBonusDodgeRate: 0,
    ShoesBonusDefence: 0,
    ShoesBonusDefenceBuffer: 0,
    ShoesBonusHitRate: 0,
    ShoesBonusCritRate: 0,
    ShoesBonusHealth: 0,
    ShoesBonusSP: 0,
    // import Boots from './img/Equipment/FootGear/Boots.gif'
    BootsBonusSTR: 0,
    BootsBonusAGI: 0,
    BootsBonusVIT: 0,
    BootsBonusINT: 0,
    BootsBonusDEX: 0,
    BootsBonusLUK: 0,
    BootsBonusAttack: 0,
    BootsBonusSpeed: 0,
    BootsBonusDodgeRate: 0,
    BootsBonusDefence: 0,
    BootsBonusDefenceBuffer: 0,
    BootsBonusHitRate: 0,
    BootsBonusCritRate: 0,
    BootsBonusHealth: 0,
    BootsBonusSP: 0,
    // import Greaves from './img/Equipment/FootGear/Greaves.gif'
    GreavesBonusSTR: 0,
    GreavesBonusAGI: 0,
    GreavesBonusVIT: 0,
    GreavesBonusINT: 0,
    GreavesBonusDEX: 0,
    GreavesBonusLUK: 0,
    GreavesBonusAttack: 0,
    GreavesBonusSpeed: 0,
    GreavesBonusDodgeRate: 0,
    GreavesBonusDefence: 0,
    GreavesBonusDefenceBuffer: 0,
    GreavesBonusHitRate: 0,
    GreavesBonusCritRate: 0,
    GreavesBonusHealth: 0,
    GreavesBonusSP: 0,
    // import BunnySlipper from './img/Equipment/FootGear/BunnySlipper.gif'
    BunnySlipperBonusSTR: 0,
    BunnySlipperBonusAGI: 0,
    BunnySlipperBonusVIT: 0,
    BunnySlipperBonusINT: 0,
    BunnySlipperBonusDEX: 0,
    BunnySlipperBonusLUK: 0,
    BunnySlipperBonusAttack: 0,
    BunnySlipperBonusSpeed: 0,
    BunnySlipperBonusDodgeRate: 0,
    BunnySlipperBonusDefence: 0,
    BunnySlipperBonusDefenceBuffer: 0,
    BunnySlipperBonusHitRate: 0,
    BunnySlipperBonusCritRate: 0,
    BunnySlipperBonusHealth: 0,
    BunnySlipperBonusSP: 0,
    // import TidalShoes from './img/Equipment/FootGear/TidalShoes.gif'
    TidalShoesBonusSTR: 0,
    TidalShoesBonusAGI: 0,
    TidalShoesBonusVIT: 0,
    TidalShoesBonusINT: 0,
    TidalShoesBonusDEX: 0,
    TidalShoesBonusLUK: 0,
    TidalShoesBonusAttack: 0,
    TidalShoesBonusSpeed: 0,
    TidalShoesBonusDodgeRate: 0,
    TidalShoesBonusDefence: 0,
    TidalShoesBonusDefenceBuffer: 0,
    TidalShoesBonusHitRate: 0,
    TidalShoesBonusCritRate: 0,
    TidalShoesBonusHealth: 0,
    TidalShoesBonusSP: 0,
    // import SiegeBoots from './img/Equipment/FootGear/SiegeBoots.gif'
    SiegeBootsBonusSTR: 0,
    SiegeBootsBonusAGI: 0,
    SiegeBootsBonusVIT: 0,
    SiegeBootsBonusINT: 0,
    SiegeBootsBonusDEX: 0,
    SiegeBootsBonusLUK: 0,
    SiegeBootsBonusAttack: 0,
    SiegeBootsBonusSpeed: 0,
    SiegeBootsBonusDodgeRate: 0,
    SiegeBootsBonusDefence: 0,
    SiegeBootsBonusDefenceBuffer: 0,
    SiegeBootsBonusHitRate: 0,
    SiegeBootsBonusCritRate: 0,
    SiegeBootsBonusHealth: 0,
    SiegeBootsBonusSP: 0,
    // import SiegeGreaves from './img/Equipment/FootGear/SiegeGreaves.gif'
    SiegeGreavesBonusSTR: 0,
    SiegeGreavesBonusAGI: 0,
    SiegeGreavesBonusVIT: 0,
    SiegeGreavesBonusINT: 0,
    SiegeGreavesBonusDEX: 0,
    SiegeGreavesBonusLUK: 0,
    SiegeGreavesBonusAttack: 0,
    SiegeGreavesBonusSpeed: 0,
    SiegeGreavesBonusDodgeRate: 0,
    SiegeGreavesBonusDefence: 0,
    SiegeGreavesBonusDefenceBuffer: 0,
    SiegeGreavesBonusHitRate: 0,
    SiegeGreavesBonusCritRate: 0,
    SiegeGreavesBonusHealth: 0,
    SiegeGreavesBonusSP: 0,
    // import VidarsBoots from './img/Equipment/FootGear/VidarsBoots.gif'
    VidarsBootsBonusSTR: 0,
    VidarsBootsBonusAGI: 0,
    VidarsBootsBonusVIT: 0,
    VidarsBootsBonusINT: 0,
    VidarsBootsBonusDEX: 0,
    VidarsBootsBonusLUK: 0,
    VidarsBootsBonusAttack: 0,
    VidarsBootsBonusSpeed: 0,
    VidarsBootsBonusDodgeRate: 0,
    VidarsBootsBonusDefence: 0,
    VidarsBootsBonusDefenceBuffer: 0,
    VidarsBootsBonusHitRate: 0,
    VidarsBootsBonusCritRate: 0,
    VidarsBootsBonusHealth: 0,
    VidarsBootsBonusSP: 0,
    // import VitalTreeShoes from './img/Equipment/FootGear/VitalTreeShoes.gif'
    VitalTreeShoesBonusSTR: 0,
    VitalTreeShoesBonusAGI: 0,
    VitalTreeShoesBonusVIT: 0,
    VitalTreeShoesBonusINT: 0,
    VitalTreeShoesBonusDEX: 0,
    VitalTreeShoesBonusLUK: 0,
    VitalTreeShoesBonusAttack: 0,
    VitalTreeShoesBonusSpeed: 0,
    VitalTreeShoesBonusDodgeRate: 0,
    VitalTreeShoesBonusDefence: 0,
    VitalTreeShoesBonusDefenceBuffer: 0,
    VitalTreeShoesBonusHitRate: 0,
    VitalTreeShoesBonusCritRate: 0,
    VitalTreeShoesBonusHealth: 0,
    VitalTreeShoesBonusSP: 0,
    // import VariantShoes from './img/Equipment/FootGear/VariantShoes.gif'
    VariantShoesBonusSTR: 0,
    VariantShoesBonusAGI: 0,
    VariantShoesBonusVIT: 0,
    VariantShoesBonusINT: 0,
    VariantShoesBonusDEX: 0,
    VariantShoesBonusLUK: 0,
    VariantShoesBonusAttack: 0,
    VariantShoesBonusSpeed: 0,
    VariantShoesBonusDodgeRate: 0,
    VariantShoesBonusDefence: 0,
    VariantShoesBonusDefenceBuffer: 0,
    VariantShoesBonusHitRate: 0,
    VariantShoesBonusCritRate: 0,
    VariantShoesBonusHealth: 0,
    VariantShoesBonusSP: 0,
    // import Sleipnir from './img/Equipment/FootGear/Sleipnir.gif'
    SleipnirBonusSTR: 0,
    SleipnirBonusAGI: 0,
    SleipnirBonusVIT: 0,
    SleipnirBonusINT: 0,
    SleipnirBonusDEX: 0,
    SleipnirBonusLUK: 0,
    SleipnirBonusAttack: 20,
    SleipnirBonusSpeed: 0.2,
    SleipnirBonusDodgeRate: 0.2,
    SleipnirBonusDefence: 20,
    SleipnirBonusDefenceBuffer: 20,
    SleipnirBonusHitRate: 0.2,
    SleipnirBonusCritRate: 0.2,
    SleipnirBonusHealth: 200,
    SleipnirBonusSP: 200,
    //ACCESSORY
    // import Clip from './img/Equipment/Accessory/Clip.gif'
    ClipBonusSTR: 0,
    ClipBonusAGI: 0,
    ClipBonusVIT: 0,
    ClipBonusINT: 0,
    ClipBonusDEX: 0,
    ClipBonusLUK: 0,
    ClipBonusAttack: 0,
    ClipBonusSpeed: 0,
    ClipBonusDodgeRate: 0,
    ClipBonusDefence: 0,
    ClipBonusDefenceBuffer: 0,
    ClipBonusHitRate: 0,
    ClipBonusCritRate: 0,
    ClipBonusHealth: 0,
    ClipBonusSP: 0,
    // import Rosary from './img/Equipment/Accessory/Rosary.gif'
    RosaryBonusSTR: 0,
    RosaryBonusAGI: 0,
    RosaryBonusVIT: 0,
    RosaryBonusINT: 0,
    RosaryBonusDEX: 0,
    RosaryBonusLUK: 0,
    RosaryBonusAttack: 0,
    RosaryBonusSpeed: 0,
    RosaryBonusDodgeRate: 0,
    RosaryBonusDefence: 0,
    RosaryBonusDefenceBuffer: 0,
    RosaryBonusHitRate: 0,
    RosaryBonusCritRate: 0,
    RosaryBonusHealth: 0,
    RosaryBonusSP: 0,
    // import VesperCore02 from './img/Equipment/Accessory/VesperCore02.gif'
    VesperCore02BonusSTR: 0,
    VesperCore02BonusAGI: 0,
    VesperCore02BonusVIT: 0,
    VesperCore02BonusINT: 0,
    VesperCore02BonusDEX: 0,
    VesperCore02BonusLUK: 0,
    VesperCore02BonusAttack: 0,
    VesperCore02BonusSpeed: 0,
    VesperCore02BonusDodgeRate: 0,
    VesperCore02BonusDefence: 0,
    VesperCore02BonusDefenceBuffer: 0,
    VesperCore02BonusHitRate: 0,
    VesperCore02BonusCritRate: 0,
    VesperCore02BonusHealth: 0,
    VesperCore02BonusSP: 0,
    // import BradiumEarring from './img/Equipment/Accessory/BradiumEarring.gif'
    BradiumEarringBonusSTR: 0,
    BradiumEarringBonusAGI: 0,
    BradiumEarringBonusVIT: 0,
    BradiumEarringBonusINT: 0,
    BradiumEarringBonusDEX: 0,
    BradiumEarringBonusLUK: 0,
    BradiumEarringBonusAttack: 0,
    BradiumEarringBonusSpeed: 0,
    BradiumEarringBonusDodgeRate: 0,
    BradiumEarringBonusDefence: 0,
    BradiumEarringBonusDefenceBuffer: 0,
    BradiumEarringBonusHitRate: 0,
    BradiumEarringBonusCritRate: 0,
    BradiumEarringBonusHealth: 0,
    BradiumEarringBonusSP: 0,
    // import GloriousRing from './img/Equipment/Accessory/GloriousRing.gif'
    GloriousRingBonusSTR: 0,
    GloriousRingBonusAGI: 0,
    GloriousRingBonusVIT: 0,
    GloriousRingBonusINT: 0,
    GloriousRingBonusDEX: 0,
    GloriousRingBonusLUK: 0,
    GloriousRingBonusAttack: 0,
    GloriousRingBonusSpeed: 0,
    GloriousRingBonusDodgeRate: 0,
    GloriousRingBonusDefence: 0,
    GloriousRingBonusDefenceBuffer: 0,
    GloriousRingBonusHitRate: 0,
    GloriousRingBonusCritRate: 0,
    GloriousRingBonusHealth: 0,
    GloriousRingBonusSP: 0,
    // import SprintRing from './img/Equipment/Accessory/SprintRing.gif'
    SprintRingBonusSTR: 0,
    SprintRingBonusAGI: 0,
    SprintRingBonusVIT: 0,
    SprintRingBonusINT: 0,
    SprintRingBonusDEX: 0,
    SprintRingBonusLUK: 0,
    SprintRingBonusAttack: 0,
    SprintRingBonusSpeed: 0,
    SprintRingBonusDodgeRate: 0,
    SprintRingBonusDefence: 0,
    SprintRingBonusDefenceBuffer: 0,
    SprintRingBonusHitRate: 0,
    SprintRingBonusCritRate: 0,
    SprintRingBonusHealth: 0,
    SprintRingBonusSP: 0,
    // import DiabolusRing from './img/Equipment/Accessory/DiabolusRing.gif'
    DiabolusRingBonusSTR: 0,
    DiabolusRingBonusAGI: 0,
    DiabolusRingBonusVIT: 0,
    DiabolusRingBonusINT: 0,
    DiabolusRingBonusDEX: 0,
    DiabolusRingBonusLUK: 0,
    DiabolusRingBonusAttack: 0,
    DiabolusRingBonusSpeed: 0,
    DiabolusRingBonusDodgeRate: 0,
    DiabolusRingBonusDefence: 0,
    DiabolusRingBonusDefenceBuffer: 0,
    DiabolusRingBonusHitRate: 0,
    DiabolusRingBonusCritRate: 0,
    DiabolusRingBonusHealth: 0,
    DiabolusRingBonusSP: 0,
    // import MedalofHonor from './img/Equipment/Accessory/MedalofHonor.gif'
    MedalofHonorBonusSTR: 0,
    MedalofHonorBonusAGI: 0,
    MedalofHonorBonusVIT: 0,
    MedalofHonorBonusINT: 0,
    MedalofHonorBonusDEX: 0,
    MedalofHonorBonusLUK: 0,
    MedalofHonorBonusAttack: 0,
    MedalofHonorBonusSpeed: 0,
    MedalofHonorBonusDodgeRate: 0,
    MedalofHonorBonusDefence: 0,
    MedalofHonorBonusDefenceBuffer: 0,
    MedalofHonorBonusHitRate: 0,
    MedalofHonorBonusCritRate: 0,
    MedalofHonorBonusHealth: 0,
    MedalofHonorBonusSP: 0,
    // import BakonawaAgimatTattoo from './img/Equipment/Accessory/BakonawaAgimatTattoo.gif'
    BakonawaAgimatTattooBonusSTR: 0,
    BakonawaAgimatTattooBonusAGI: 0,
    BakonawaAgimatTattooBonusVIT: 0,
    BakonawaAgimatTattooBonusINT: 0,
    BakonawaAgimatTattooBonusDEX: 0,
    BakonawaAgimatTattooBonusLUK: 0,
    BakonawaAgimatTattooBonusAttack: 0,
    BakonawaAgimatTattooBonusSpeed: 0,
    BakonawaAgimatTattooBonusDodgeRate: 0,
    BakonawaAgimatTattooBonusDefence: 0,
    BakonawaAgimatTattooBonusDefenceBuffer: 0,
    BakonawaAgimatTattooBonusHitRate: 0,
    BakonawaAgimatTattooBonusCritRate: 0,
    BakonawaAgimatTattooBonusHealth: 0,
    BakonawaAgimatTattooBonusSP: 0,
    // import Brisingamen from './img/Equipment/Accessory/Brisingamen.gif'
    BrisingamenBonusSTR: 0,
    BrisingamenBonusAGI: 0,
    BrisingamenBonusVIT: 0,
    BrisingamenBonusINT: 0,
    BrisingamenBonusDEX: 0,
    BrisingamenBonusLUK: 0,
    BrisingamenBonusAttack: 0,
    BrisingamenBonusSpeed: 0,
    BrisingamenBonusDodgeRate: 0,
    BrisingamenBonusDefence: 0,
    BrisingamenBonusDefenceBuffer: 0,
    BrisingamenBonusHitRate: 0,
    BrisingamenBonusCritRate: 0,
    BrisingamenBonusHealth: 0,
    BrisingamenBonusSP: 0,
    // import Megingjard from './img/Equipment/Accessory/Megingjard.gif'
    MegingjardBonusSTR: 5,
    MegingjardBonusAGI: 5,
    MegingjardBonusVIT: 5,
    MegingjardBonusINT: 5,
    MegingjardBonusDEX: 5,
    MegingjardBonusLUK: 5,
    MegingjardBonusAttack: 50,
    MegingjardBonusSpeed: 0.05,
    MegingjardBonusDodgeRate: 0.05,
    MegingjardBonusDefence: 50,
    MegingjardBonusDefenceBuffer: 50,
    MegingjardBonusHitRate: 0.05,
    MegingjardBonusCritRate: 0.05,
    MegingjardBonusHealth: 500,
    MegingjardBonusSP: 500,
}


const equipmentAllStatsReducer = (state = Fn, action) => {
    switch(action.type){
        default:
            return state;
    }
}

export default equipmentAllStatsReducer;